import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/landing.css';

interface LandingNavProps {
  /** Always render the solid frosted bar (for light-background pages). */
  solid?: boolean;
}

export default function LandingNav({ solid = false }: LandingNavProps) {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(solid);

  useEffect(() => {
    if (solid) return;
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [solid]);

  return (
    <nav className={`landing-nav${scrolled ? ' landing-nav--scrolled' : ''}`}>
      <div className="landing-nav-content">
        <div className="landing-logo" onClick={() => navigate('/')}>
          CrewCast
        </div>
        <div className="landing-nav-links">
          <button onClick={() => navigate('/login')} className="landing-nav-link">
            Login
          </button>
          <button onClick={() => navigate('/contact')} className="landing-nav-link">
            Contact
          </button>
          <button onClick={() => navigate('/blog')} className="landing-nav-link">
            Blog
          </button>
        </div>
      </div>
    </nav>
  );
}
